export const getDevices = `
  query {
    getDevices {
      device_id
      metadata {
        friendly_name
      }
    }
  }
`;

export const getData = `
  query getData($device_id: ID!, $date: String!) {
    getData(device_id: $device_id, date: $date) {
      time
      flow_temperature
      return_temperature
      room_temperature
      room_humidity
    }
  }
`;


export const getDevice = `
  query getDevice($device_id: ID!) {
    getDevice(device_id: $device_id) {
      metadata {
        friendly_name
        description
        latitude
        longitude
      }
    }
  }
`;

export const getHeatingStatus = `
  query getHeatingStatus($device_id: ID!, $date: String) {
    getHeatingStatus(device_id: $device_id, date: $date) {
      time
      heating_status
    }
  }
`;


export const getTemperatureForecast = `
  query getTemperatureForecast($device_id: ID!, $date: String!) {
    getTemperatureForecast(device_id: $device_id, date: $date) {
      time
      internal_temperature
      external_temperature
      wall_internal_temperature
      wall_external_temperature
      actual_mean_temperature
    }
  }
`;

export const putDeviceMetadata = `
  mutation putDeviceMetadata(
    $device_id: ID!
    $friendly_name: String
    $description: String
    $latitude: Float
    $longitude: Float
  ) {
    putDeviceMetadata(
      device_id: $device_id
      friendly_name: $friendly_name
      description: $description
      latitude: $latitude
      longitude: $longitude
    ) {
      device_id
      friendly_name
      description
      latitude
      longitude
    }
  }
`;

export const getHeatingSchedule = `
  query getHeatingSchedule($device_id: ID!) {
    getHeatingSchedule(device_id: $device_id) {
      device_id
      event_id
      target_time
      target_temperature
      label
      preheat_start
      duration_minutes
    }
  }
`;

export const putHeatingEvent = `
  mutation putHeatingEvent(
    $device_id: ID!
    $event_id: String
    $target_time: String!
    $target_temperature: Float!
    $label: String
    $duration_minutes: Int
  ) {
    putHeatingEvent(
      device_id: $device_id
      event_id: $event_id
      target_time: $target_time
      target_temperature: $target_temperature
      label: $label
      duration_minutes: $duration_minutes
    ) {
      device_id
      event_id
      target_time
      target_temperature
      label
      preheat_start
      duration_minutes
    }
  }
`;

export const deleteHeatingEvent = `
  mutation deleteHeatingEvent($device_id: ID!, $event_id: String!) {
    deleteHeatingEvent(device_id: $device_id, event_id: $event_id) {
      device_id
      event_id
    }
  }
`;

export const solveSchedule = `
  query solveSchedule($device_id: ID!) {
    solveSchedule(device_id: $device_id) {
      heating_windows {
        start
        end
      }
      forecast {
        time
        internal_temperature
        external_temperature
        heating_on
      }
      total_heating_hours
    }
  }
`;

export const getSolarForecast = `
  query getSolarForecast($device_id: ID!, $date: String!) {
    getSolarForecast(device_id: $device_id, date: $date) {
      time
      predicted_power
      predicted_yield
    }
  }
`;

export const getSolaxData = `
  query getSolaxData($date: String!) {
    getSolaxData(date: $date) {
      time
      acpower
      powerdc1
      powerdc2
      yieldtoday
      yieldtotal
      feedinpower
      feedinenergy
      consumeenergy
      batPower
      soc
      inverterStatus
    }
  }
`;

const DAIKIN_STATUS_FIELDS = `
      device_count
      from_cache
      stale
      fetched_at
      calls_remaining
      objective {
        power
        setpoint
        target
        phase
        measured
        measured_at
      }
      conflict {
        device_id
        field
        expected
        actual
      }
      units {
        device_id
        name
        model
        online
        power
        operation_mode
        setpoint
        setpoint_min
        setpoint_max
        setpoint_step
        fan_mode
        fan_speed
        fan_speed_max
        room_temperature
        outdoor_temperature
        auto_state
        schedule_enabled
        schedule_next_action
        holiday_mode
        mode_conflict
        error_state
        error_code
      }
`;

export const getDaikinStatus = `
  query getDaikinStatus($refresh: Boolean) {
    getDaikinStatus(refresh: $refresh) {${DAIKIN_STATUS_FIELDS}}
  }
`;

export const setDaikinPower = `
  mutation setDaikinPower($device_id: ID!, $value: String!, $expected: String) {
    setDaikinPower(device_id: $device_id, value: $value, expected: $expected) {${DAIKIN_STATUS_FIELDS}}
  }
`;

export const setDaikinSetpoint = `
  mutation setDaikinSetpoint($device_id: ID!, $value: Float!, $expected: Float) {
    setDaikinSetpoint(device_id: $device_id, value: $value, expected: $expected) {${DAIKIN_STATUS_FIELDS}}
  }
`;

export const setDaikinFanSpeed = `
  mutation setDaikinFanSpeed($device_id: ID!, $value: Int!, $expected: Int) {
    setDaikinFanSpeed(device_id: $device_id, value: $value, expected: $expected) {${DAIKIN_STATUS_FIELDS}}
  }
`;

export const getMySites = `
  query getMySites {
    getMySites {
      site_id
      name
      role
      device_ids
      has_solax
      has_daikin
      has_control
    }
  }
`;
